import ContentLoader from "react-content-loader";

const ConsoleLogLoader: React.FC = () =>
    <ContentLoader viewBox="0 0 931 577" width="100%">
        <rect x="0" y="0" rx="5" ry="5" width="931" height="577" />
    </ContentLoader>;

export default ConsoleLogLoader;
